import styled from 'styled-components'

export const InventoryActions = styled.div<TSFixMe>`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  margin-top: -20px;
`
